import * as type from "./type";

const initialState = {
    getSupportDetails: null,
    addSupport: null,
    deleteSupport:null
};

const SupportDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_SUPPORT_DETAILS_LIST_REQUEST:
            return { ...state, getSupportDetails: null };
        case type.GET_SUPPORT_DETAILS_LIST_SUCCESS:
            return { ...state, getSupportDetails: action.payload };
        case type.ADD_SUPPORT_DETAILS_REQUEST:
            return { ...state, addSupport: null };
        case type.ADD_SUPPORT_DETAILS_SUCCESS:
            return { ...state, addSupport: action.payload };
        case type.DELETE_SUPPORT_DETAILS_REQUEST:
            return { ...state, deleteSupport: null };
        case type.DELETE_SUPPORT_DETAILS_SUCCESS:
            return { ...state, deleteSupport: action.payload };
        default:
            return {
                ...state,
            };
    }
};
export default SupportDetailsReducer;
